export const getTimeDifference = (date1: Date, date2: Date) => {
  return date2.getTime() - date1.getTime();
};

export const getAbsTimeDifferenceInSeconds = (date1: Date, date2: Date) => {
  const duration = getTimeDifference(date1, date2) / 1000;
  return Math.abs(duration);
};
